import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SectionLabel from "../components/SectionLabel";
import Video from "../components/Video";
import { SERVICES } from "../data/site";

export default function Services() {
  const [active, setActive] = useState(null);
  const current = SERVICES.find((s) => s.n === active);

  return (
    <section className="relative overflow-hidden px-6 md:px-12 lg:px-16 py-32 md:py-48" data-testid="services">
      {/* background video reveal */}
      <AnimatePresence>
        {current && (
          <motion.div
            key={current.n}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.22 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="pointer-events-none absolute inset-0 z-0"
          >
            <Video src={current.video} priority className="h-full w-full" />
            <div className="absolute inset-0 bg-black/40" />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="relative z-10">
        <SectionLabel index="06">WHAT WE DO</SectionLabel>

        <div className="mt-14 border-t border-white/[0.08]">
          {SERVICES.map((s) => {
            const isOn = active === s.n;
            return (
              <div
                key={s.n}
                onMouseEnter={() => setActive(s.n)}
                onMouseLeave={() => setActive(null)}
                data-testid={`service-${s.n}`}
                className="group border-b border-white/[0.08] py-7 md:py-9"
              >
                <div className="flex items-baseline justify-between gap-6">
                  <div className="flex items-baseline gap-5 md:gap-8">
                    <span className="label text-lav-400/80">{s.n}</span>
                    <motion.span
                      animate={{ x: isOn ? 16 : 0, color: isOn ? "#A78BFA" : "#ffffff" }}
                      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                      className="text-big uppercase leading-none"
                    >
                      {s.title}
                    </motion.span>
                  </div>
                  <motion.span
                    animate={{ rotate: isOn ? 45 : 0, color: isOn ? "#A78BFA" : "rgba(255,255,255,0.4)" }}
                    className="text-2xl"
                  >
                    +
                  </motion.span>
                </div>
                <AnimatePresence>
                  {isOn && (
                    <motion.p
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden pl-12 md:pl-20 pt-4 max-w-2xl text-sm md:text-base font-light text-white/55"
                    >
                      {s.desc}
                    </motion.p>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
